// extracted by mini-css-extract-plugin
export default {"pageDescription":"pageDescription--oi8a6","socialSection":"socialSection--oi8a6"};